// apps/web/src/api/auth.ts
// 认证相关 API — 登录、注册、获取当前用户

import api from "./client";
import { useAuthStore } from "@/stores/authStore";
import type { AuthResponse, UserDTO } from "@examfast/shared-types";

const BASE = "auth";

/** 注册 */
export async function registerApi(data: {
  email: string;
  password: string;
  nickname?: string;
}): Promise<AuthResponse> {
  return api.post<AuthResponse>(`${BASE}/register`, data);
}

/** 登录 */
export async function loginApi(data: {
  email: string;
  password: string;
}): Promise<AuthResponse> {
  return api.post<AuthResponse>(`${BASE}/login`, data);
}

/** 获取当前登录用户信息 */
export async function fetchMe(): Promise<UserDTO> {
  return api.get<UserDTO>(`${BASE}/me`);
}

/** 退出登录（前端清除 token） */
export function logoutApi(): void {
  useAuthStore.getState().logout();
}
